import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CreditCardIcons',
  setup(__props) {

const icons: [source: string, alt: string][] = [
	["/assets/images/credit-cards/visa.svg", "Visa Card"],
	["/assets/images/credit-cards/mastercard.svg", "Mastercard"],
	["/assets/images/credit-cards/discover.svg", "Discover Card"],
	["/assets/images/credit-cards/amex.svg", "American Express"],
];

return { __sfc: true,icons }
}

})